import React from "react";

interface SummaryCardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
  subtitle?: string;
  highlight?: boolean;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  icon,
  title,
  value,
  subtitle,
  highlight = false,
}) => {
  return (
    <div className={`summary-card ${highlight ? "highlight" : ""}`}>
      <div className="card-icon">{icon}</div>

      <div className="card-content">
        <p className="card-title">{title}</p>
        <h3 className="card-value">{value}</h3>
        {subtitle && <p className="card-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default SummaryCard;